export function navigate(path: string) {
  if (!window._navigate) {
    throw new Error("navigate is not initialized");
  }
  window._navigate(path);
}
